// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__330-2","logo":"styles_logo__2C9JT","app_mode":"styles_app_mode__2iak0","tenant":"styles_tenant__1u4k7","menuwrap":"styles_menuwrap__3fH4o"};